import React from 'react';
import { Skeleton } from '@mui/material';

import './mobile-product-list-header-skeleton-style.scss';

import MobileHeaderSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileHeaderSkeleton';

import { SKELETON_COLOR } from "@src/utils/constants";

interface IProps {
  type: 'normal' | 'category' | 'brand';
}

const MobileProductListHeaderSkeleton = ({ type }: IProps) => {
  return (
    <div id='mobile-product-list-header-skeleton-wrapper'>
      <MobileHeaderSkeleton isMain={false} hasBorderBottom={type !== 'brand'} />

      {
        type === 'brand' &&
        <div className='brand-top-area-skeleton'>
          <Skeleton variant="rectangular" width="100%" height={280} style={{ backgroundColor: SKELETON_COLOR }} />
          <div className='brand-text-area'>
            <Skeleton variant="rectangular" width={140} height={32} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
            <div className='brand-text-list'>
              <Skeleton variant="rectangular" width={105} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
              <Skeleton variant="rectangular" width={105} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
              <Skeleton variant="rectangular" width={105} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
              <Skeleton variant="rectangular" width={105} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
            </div>
          </div>
        </div>
      }

      {
        type === 'category' &&
        <div className='category-top-area-skeleton'>
          <Skeleton variant="rectangular" width={120} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={120} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={120} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={120} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        </div>
      }

      <div className='common-skeleton'>
        <Skeleton variant="rectangular" width={80} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        <div className='icon-wrapper'>
          <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        </div>
      </div>
    </div>
  );
};

export default MobileProductListHeaderSkeleton;
